export default {"src":"/_next/static/media/app-store_badge_tr.e75384e9.svg","height":40,"width":151};